module.exports = __webpack_public_path__ + "img/inputsearch.0515ab6b.svg";